export interface UploadSubmissionGate {
  current: boolean;
}

interface RunUploadSubmissionOptions<T> {
  gate: UploadSubmissionGate;
  onPendingChange: (pending: boolean) => void;
  action: () => Promise<T>;
}

/**
 * Starts one upload submission synchronously and rejects re-entry until it settles.
 * The pending callback runs before the async action so the UI can acknowledge a
 * drop immediately, including during file validation and hash calculation.
 */
export async function runUploadSubmission<T>({
  gate,
  onPendingChange,
  action,
}: RunUploadSubmissionOptions<T>): Promise<T | undefined> {
  if (gate.current) {
    return undefined;
  }

  gate.current = true;
  onPendingChange(true);
  try {
    return await action();
  } finally {
    gate.current = false;
    onPendingChange(false);
  }
}
